import Markdown from 'markdown-to-jsx'
import { FunctionComponent } from 'react'

interface Prop {
  content: string
  textColor?: string
  textSize?: string
}

const RichText: FunctionComponent<Prop> = ({ content, textColor, textSize }) => {
  if (content === null) {
    return <></>
  }

  const baseTextClass = `${textColor ?? 'text-textHigh'} ${textSize ?? 'text-base'} break-words`
  const headingBaseClass = `${textColor ?? 'text-textHigh'} break-words`

  return (
    <div>
      <Markdown
        options={{
          wrapper: ({ children, ...props }) => (
            <span className={`${baseTextClass} whitespace-pre-line`} {...props}>
              {children}
            </span>
          ),
          overrides: {
            h1: {
              props: {
                className: `${headingBaseClass} text-2xl`
              }
            },
            h2: {
              props: {
                className: `${headingBaseClass} text-xl`
              }
            },
            h3: {
              props: {
                className: `${headingBaseClass} text-lg`
              }
            },
            h4: {
              props: {
                className: `${headingBaseClass} text-base`
              }
            },
            h5: {
              props: {
                className: `${headingBaseClass} text-sm`
              }
            },
            h6: {
              props: {
                className: `${headingBaseClass} text-xs`
              }
            },
            ol: {
              props: {
                className: 'list-decimal list-inside'
              }
            },
            ul: {
              props: {
                className: 'list-disc list-inside'
              }
            },
            li: {
              props: {
                className: `${baseTextClass}`
              }
            },
            a: {
              props: {
                className: `text-blue-600 ${textSize ?? 'text-base'} hover:underline`
              }
            },
            blockquote: {
              props: {
                className: `${baseTextClass} border-l-2 border-white/20 pl-3 italic`
              }
            },
            p: {
              props: {
                className: baseTextClass
              }
            },
            span: {
              props: {
                className: baseTextClass
              }
            },
            strong: {
              props: {
                className: baseTextClass
              }
            },
            b: {
              props: {
                className: baseTextClass
              }
            },
            i: {
              props: {
                className: `${baseTextClass} italic`
              }
            },
            em: {
              props: {
                className: `${baseTextClass} italic`
              }
            },
            pre: {
              props: {
                className: `${baseTextClass} whitespace-pre-wrap overflow-auto`
              }
            },
            code: {
              props: {
                className: `${baseTextClass}`
              }
            },
            table: {
              props: {
                className: 'w-full border-collapse'
              }
            },
            th: {
              props: {
                className: `text-textHigh border border-white/10 text-left font-semibold md:text-base text-[10px]`
              }
            },
            td: {
              props: {
                className: `text-textHigh border border-white/10 align-top md:text-base text-[10px]`
              }
            },
            hr: {
              props: {
                className: 'my-3 border-white/10'
              }
            }
          }
        }}
      >
        {content}
      </Markdown>
    </div>
  )
}

export default RichText
